import {IApplicationState} from '../../../types/types';

export const hasOpenedBoardSelector = (
    state: IApplicationState
) => {
    return !!state.model.activeDashboardId;
};
